import { Divider, Grid, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import React from 'react';
import { BusinessTypes } from '../../../../enums/business-type';
import { UpdateMerchantOnboardingFormValues } from '../../../../type/update-merchant-onboarding-form-values.types';

interface UpdateMechantInfoProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  businessHandleError: string;
  setBusinessHandleError: React.Dispatch<React.SetStateAction<string>>;
  isNonAdminInterface: boolean;
}
function UpdateMechantInfo(props: UpdateMechantInfoProps) {
  const {
    form,
    businessHandleError,
    setBusinessHandleError,
    isNonAdminInterface,
  } = props;
  const label = {
    merchantName: 'Company name',
    merchantBusinessName: 'Registered business name',
    businessHandle: 'Name for payment link',
    merchantCompanyTin: 'Company TIN',
  };
  const placeHolder = {
    merchantName: 'Company name',
    merchantBusinessName: 'Registered business name',
    businessHandle: 'Name for payment link',
    merchantCompanyTin: 'Company TIN',
  };

  return (
    <>
      <Grid>
        <Grid.Col>
          <TextInput
            data-cy='merchantName'
            label={label.merchantName}
            value={form.values.merchantName}
            placeholder={placeHolder.merchantName}
            onChange={(event) => {
              form.setFieldValue('merchantName', event.currentTarget.value);
            }}
            error={form.errors.merchantName}
          />
        </Grid.Col>
        {form.values.businessTypeId !== BusinessTypes.STARTER && (
          <Grid.Col>
            <TextInput
              data-cy='merchantBusinessName'
              label={label.merchantBusinessName}
              value={form.values.merchantBusinessName}
              placeholder={placeHolder.merchantBusinessName}
              onChange={(event) => {
                form.setFieldValue(
                  'merchantBusinessName',
                  event.currentTarget.value
                );
                if (isNonAdminInterface) {
                  form.setFieldValue(
                    'businessHandle',
                    event.currentTarget.value
                      .toLowerCase()
                      .replace(/\s/g, '_')
                      .replace(/[^A-Za-z0-9-_]/g, '-')
                  );
                  setBusinessHandleError('');
                }
              }}
              error={form.errors.merchantBusinessName}
            />
          </Grid.Col>
        )}
        <Grid.Col md={6}>
          <TextInput
            data-cy='businessHandle'
            label={label.businessHandle}
            value={form.values.businessHandle}
            placeholder={placeHolder.businessHandle}
            onChange={(event) => {
              if (isNonAdminInterface) {
                return;
              }
              form.setFieldValue(
                'businessHandle',
                event.currentTarget.value
                  .toLowerCase()
                  .replace(/\s/g, '_')
                  .replace(/[^A-Za-z0-9-_]/g, '-')
              );
              setBusinessHandleError('');
            }}
            disabled={isNonAdminInterface}
            error={businessHandleError}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <TextInput
            data-cy='merchantCompanyTin'
            label={label.merchantCompanyTin}
            value={form.values.merchantCompanyTin}
            placeholder={placeHolder.merchantCompanyTin}
            onChange={(event) => {
              form.setFieldValue(
                'merchantCompanyTin',
                event.currentTarget.value
              );
            }}
            error={form.errors.merchantCompanyTin}
          />
        </Grid.Col>
        <Grid.Col>
          <Divider my='md' />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default UpdateMechantInfo;
